<template>
  <v-container
    id="customers"
    tag="section"
  >
    <customer-list
      :customers="customers"
      @new="CustomerNewHandler"
      @refresh="CustomerRefreshHandler"
      @overview="CustomerOverviewHandler"
      @edit="CustomerEditHandler"
      @itemClicked="CustomerOverviewHandler"
    />
  </v-container>
</template>

<script>
  import CustomerList from '@/views/components/custom/lists/CustomerList.vue'

  export default {
    components: {
      CustomerList,
    },
    data: () => ({
    }),
    computed: {
      customers () {
        return this.$store.state.customers.data
      },
    },
    created: async function () {
      if (this.customers.length === 0) {
        await this.RefreshCustomers()
      }
    },
    methods: {
      async RefreshCustomers () {
        await this.$store.dispatch('RefreshCustomers')
      },
      CustomerNewHandler () {
        this.$router.push({ name: 'NewCustomer' })
      },
      async CustomerRefreshHandler () {
        await this.RefreshCustomers()
      },
      CustomerOverviewHandler (customerUid) {
        this.$router.push({ name: 'CustomerDetails', params: { uid: customerUid } })
      },
      CustomerEditHandler (customerUid) {
        this.$router.push({ name: 'Customer', params: { uid: customerUid } })
      },
    },
  }
</script>
